module.exports = __webpack_public_path__ + "img/ic_swal_error_reject.24cd1ac7.png";